import { Button, Modal, TextInput, Select } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useState, useEffect } from 'react'
import { useAxiosApi } from '@/hooks/useAxiosApi'

export default function ShopifyVariantWCDEdit({
    product,
    variant,
    fetchProduct,
}) {
    const [opened, { open, close }] = useDisclosure(false)
    const [isSaving, setIsSaving] = useState(false)
    const { requestPatch } = useAxiosApi()

    const [jewels, setJewels] = useState(variant.wcd_jewels)
    const [power, setPower] = useState(variant.wcd_power)
    const [strap, setStrap] = useState(variant.wcd_strap)
    const [caseValue, setCase] = useState(variant.wcd_case ?? 'Stainless Steel')

    const saveChildren = async () => {
        setIsSaving(true)

        await requestPatch(`/shopify/variants/${variant.id}`, {
            wcd_jewels: jewels,
            wcd_power: power,
            wcd_strap: strap,
            wcd_case: caseValue,
        })

        await fetchProduct()
        close()
    }

    useEffect(() => {
        if (opened) {
            setIsSaving(false)
            setJewels(variant.wcd_jewels)
            setPower(variant.wcd_power)
            setStrap(variant.wcd_strap)
            setCase(variant.wcd_case)
        }
    }, [opened, variant.wcd_jewels, variant.wcd_power, variant.wcd_strap, variant.wcd_case])

    return (
        <>
            <Modal
                opened={opened}
                position="right"
                onClose={close}
                size="xl"
                title={'WCD : ' + product.title + ' - ' + variant.title}
            >
                <div className="flex flex-col">
                    <div className="flex flex-col gap-2">
                        <TextInput
                            label="Jewels"
                            value={jewels}
                            onChange={(e) => setJewels(e.currentTarget.value)}
                        />

                        <Select
                            label="Power"
                            data={['Wind-Up', 'Self-Winding']}
                            value={power}
                            onChange={(value) => setPower(value)}
                        />

                        <Select
                            label="Strap"
                            data={['Leather', 'Rubber', 'Stainless Steel']}
                            value={strap}
                            onChange={(value) => setStrap(value)}
                        />

                        <Select
                            label="Case"
                            data={['Stainless Steel', 'Bronze', 'Titanium']}
                            value={caseValue}
                            onChange={(value) => setCase(value)}
                        />
                    </div>

                    <div className="flex gap-2 ml-auto mt-5">
                        <Button onClick={close} variant="default">
                            Annuler
                        </Button>

                        <Button onClick={saveChildren} loading={isSaving}>
                            Sauvegarder les modifications
                        </Button>
                    </div>
                </div>
            </Modal>

            <Button variant="default" onClick={open} className="mt-2 mr-auto">
                Modifier le Watch Clock Detail
            </Button>
        </>
    )
}